import { makeStyles } from "@material-ui/core/styles";

export const createAuthoritiesStyle = makeStyles(() => ({




}));
